var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowBackOutlined(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 11H4C3.45614 11 3 11.4561 3 12C3 12.5439 3.45614 13 4 13H20C20.5439 13 21 12.5439 21 12C21 11.4561 20.5439 11 20 11ZM4.70175 12.7018L11.7018 5.70175C11.8947 5.52632 12 5.2807 12 5C12 4.45614 11.5439 4 11 4C10.7193 4 10.4737 4.10526 10.2982 4.29824L3.29825 11.2982C3.10526 11.4737 3 11.7193 3 12C3 12.5439 3.45614 13 4 13C4.2807 13 4.52632 12.8947 4.70175 12.7018ZM11.7018 18.2982L4.70175 11.2982C4.52632 11.1053 4.2807 11 4 11C3.45614 11 3 11.4561 3 12C3 12.2807 3.10526 12.5263 3.29825 12.7018L10.2982 19.7018C10.4737 19.8947 10.7193 20 11 20C11.5439 20 12 19.5439 12 19C12 18.7193 11.8947 18.4737 11.7018 18.2982Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBackOutlined);
export default __webpack_public_path__ + "static/media/arrow_back_outlined.5251df06.svg";
export { ForwardRef as ReactComponent };